import { render, staticRenderFns, recyclableRender, components } from "./special-zone.vue?vue&type=template&id=1245bff4&scoped=true&"
var renderjs
import script from "./special-zone.vue?vue&type=script&lang=js&"
export * from "./special-zone.vue?vue&type=script&lang=js&"
import style0 from "./special-zone.vue?vue&type=style&index=0&lang=css&"
import style1 from "./special-zone.vue?vue&type=style&index=1&id=1245bff4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1245bff4",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/special-zone/special-zone.vue"
export default component.exports